// One venue in the directory: its cover, name, where it is, whether it is open now, and how far away (when the
// directory computed a distance). The whole card is one link to the venue's page.

import { useTranslation } from '@clavian/i18n/react';
import type { PublicVenue } from '@clavian/api-client';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { addressLine, coverUrl, distanceKm } from '../lib/venue';

export function VenueCard({ venue }: { readonly venue: PublicVenue }): ReactNode {
  const { t } = useTranslation('player');
  const cover = coverUrl(venue);
  const where = addressLine(venue.address);
  const km = distanceKm(venue);

  return (
    <Link to="/venues/$slug" params={{ slug: venue.slug }} className="pw-venue-card">
      <span className="pw-venue-card__art">
        {cover ? (
          <img src={cover} alt="" loading="lazy" decoding="async" width={640} height={360} />
        ) : (
          <span className="pw-venue-card__placeholder" aria-hidden="true">
            {venue.name.slice(0, 1)}
          </span>
        )}
        <span className={`pw-pill ${venue.openNow ? 'pw-pill--open' : 'pw-pill--closed'}`}>
          {venue.openNow ? t('venues.openLabel') : t('venues.closedLabel')}
        </span>
      </span>
      <span className="pw-venue-card__body">
        <span className="pw-venue-card__name">{venue.name}</span>
        {where ? <span className="pw-venue-card__where">{where}</span> : null}
        {km === null ? null : <span className="pw-venue-card__distance">{t('venues.distance', { km })}</span>}
      </span>
    </Link>
  );
}
